module.exports = __webpack_public_path__ + "static/media/veyu-logo.5cf773df.svg";